module.exports = __webpack_public_path__ + "img/tip.bf5f1233.png";